import React from 'react'

const View = ({ children, flex, flexDirection, justifyContent, alignItems, style, ...props }) => {

  return (
    <div { ...props} style={{
      display: 'flex', flexDirection: flexDirection ?? 'row',
      justifyContent: justifyContent ?? 'center', alignItems: alignItems ?? 'center', ...style
    }}>{children}</div>
  )
}

export default View